var exports = {
  "Q": "AuthorLink__yuu1DZ",
  "y": "CommitAttributionContainer__AilSky",
};

module.exports = exports;
